import React, { useState, useEffect } from 'react';
import { Trophy, Star } from 'phosphor-react';
import { motion, AnimatePresence } from 'framer-motion';
import Confetti from 'react-confetti';
import axios from 'axios';
import { API_BASE_URL } from '../config';

const EndGameScreen = () => {
  const [stage, setStage] = useState(1);
  const [showConfetti, setShowConfetti] = useState(true);
  const [userData, setUserData] = useState(null);
  const username = localStorage.getItem('username');

  useEffect(() => {
    const fetchAllUserData = async () => {
      try {
        const [userData, rankingData] = await Promise.all([
          axios.get(`${API_BASE_URL}/user-data`, { params: { username } }),
          axios.get(`${API_BASE_URL}/ranking/${username}`)
        ]);

        setUserData({
          username: userData.data.display_name || username,
          points: rankingData.data.total_points || 0,
          rank: rankingData.data.rank || '-'
        });
      } catch (error) {
        console.error('Error fetching user data:', error);
      }
    };

    fetchAllUserData();
  }, [username]);

  useEffect(() => {
    const timer1 = setTimeout(() => {
      setStage(2);
      setShowConfetti(false);
    }, 5000);
    const timer2 = setTimeout(() => setStage(3), 10000);
    
    return () => {
      clearTimeout(timer1);
      clearTimeout(timer2);
    };
  }, []);

  const stageVariants = {
    initial: { opacity: 0, scale: 0.8 },
    animate: { opacity: 1, scale: 1 },
    exit: { opacity: 0, scale: 1.2 }
  };

  return (
    <div className="fixed inset-0 z-50 bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 overflow-hidden">
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,var(--tw-gradient-stops))] from-blue-900/20 via-transparent to-transparent"></div>
      </div>

      {showConfetti && (
        <Confetti
          width={window.innerWidth}
          height={window.innerHeight}
          recycle={false}
          numberOfPieces={200}
          colors={['#3B82F6', '#1D4ED8', '#2563EB', '#444']}
        />
      )}

      <AnimatePresence mode="wait">
        {stage === 1 && userData && (
          <motion.div
            key="stage1"
            className="absolute inset-0 flex items-center justify-center"
            variants={stageVariants}
            initial="initial"
            animate="animate"
            exit="exit"
            transition={{ type: "spring", duration: 0.8 }}
          >
            <div className="text-center">
              <motion.div
                initial={{ y: -50, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ delay: 0.3 }}
              >
                <Trophy size={120} weight="fill" className="text-blue-400 mx-auto mb-8 drop-shadow-[0_0_30px_rgba(59,130,246,0.3)]" />
              </motion.div>
              
              <motion.div 
                initial={{ y: 50, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ delay: 0.5 }}
                className="space-y-6"
              >
                <h2 className="text-5xl font-black text-blue-400">{userData.username}</h2>
                <div className="flex justify-center gap-8 text-2xl text-gray-400">
                  <div className="flex items-center gap-2">
                    <Star weight="fill" className="text-yellow-500" />
                    Miejsce #{userData.rank}
                  </div>
                  <div>{userData.points} punktów</div>
                </div>
              </motion.div>
            </div>
          </motion.div>
        )}

        {stage === 2 && (
          <motion.div
            key="stage2"
            className="absolute inset-0 flex items-center justify-center"
            variants={stageVariants}
            initial="initial"
            animate="animate"
            exit="exit"
          >
            <h1 className="text-5xl font-black text-blue-400 text-center">
              Dziękujemy za udział w grze!
            </h1>
          </motion.div>
        )}

        {stage === 3 && (
          <motion.div
            key="stage3"
            className="absolute inset-0 flex items-center justify-center"
            variants={stageVariants}
            initial="initial"
            animate="animate"
            exit="exit"
          >
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2 }}
            >
              <p className="text-4xl font-black text-blue-400">
                Zespół Aperto
              </p>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default EndGameScreen;
